const FTT = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M5.68596 1.27383C10.4673 1.27236 15.2489 1.27236 20.0308 1.27383C20.0323 2.82486 20.0323 4.37562 20.0308 5.92612C15.2494 5.92759 10.4678 5.92759 5.68596 5.92612C5.68443 4.37509 5.68443 2.82433 5.68596 1.27383Z"
        fill="#02A6C2"
      />
      <path
        d="M0.0379823 7.67642C1.58056 7.6684 3.1234 7.6684 4.66651 7.67642C4.67451 9.22451 4.67451 10.7729 4.66651 12.3215C3.12347 12.3294 1.58063 12.3296 0.0379823 12.3219C0.0299825 10.7735 0.0299825 9.22504 0.0379823 7.67642Z"
        fill="#5FCADE"
      />
      <path
        d="M5.68964 7.67641C9.14073 7.66905 12.5916 7.66905 16.0422 7.67641C16.0495 9.2245 16.0495 10.7728 16.0422 12.3215C12.5912 12.3287 9.14033 12.3287 5.68964 12.3215C5.68244 10.7733 5.68244 9.22496 5.68964 7.67641Z"
        fill="#5FCADE"
      />
      <path
        d="M5.69378 14.0804C7.23375 14.0636 8.77346 14.0636 10.3129 14.0804C10.3289 15.6249 10.3291 17.1701 10.3136 18.716C8.77363 18.7313 7.23395 18.731 5.69458 18.7152C5.67858 17.1709 5.67831 15.6259 5.69378 14.0804Z"
        fill="#ABEBF4"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default FTT;
